import { commentSchema } from "@/Schemas/commentSchema";
import { z } from "zod";

export const CommentFormSchema = commentSchema;

export type CommentForm = z.infer<typeof CommentFormSchema>;
